import React, { useCallback, useContext, useEffect, useMemo, useState } from "react"
import { Box, Chip, Dialog, DialogContent } from "@mui/material"
import { BoxFC } from "components/BoxCustom"
import PaperComponent from "components/PaperComponent"
import { DialogHeader } from "components/dialog/DialogHeader"
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import dayjs from "dayjs"

const logFlgConfig = {
  A: { label: "เพิ่ม", color: "success" },
  E: { label: "แก้ไข", color: "warning" },
  D: { label: "ลบ", color: "error" },
}

const FIXED_FIRST = [
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: "center",
  },
  {
    field: "ModDte",
    headerName: "วันเวลา",
    width: 145,
    valueFormatter: ({ value }) => value ? dayjs(value).format("DD/MM/YY HH:mm:ss") : "-",
  },
  {
    field: "LogFlg",
    headerName: "การกระทำ",
    width: 90,
    align: "center",
    renderCell: ({ value }) => {
      const cfg = logFlgConfig[value] || { label: value, color: "default" }
      return <Chip label={cfg.label} color={cfg.color} size="small" />
    },
  },
  {
    field: "ModAccNm",
    headerName: "ผู้ทำรายการ",
    width: 160,
  },
]

const FIXED_LAST = [
  {
    field: "LogRmk",
    headerName: "หมายเหตุ",
    width: 160,
  },
]

const LogViewDialog = ({ columns, colNm, width, datetimeFormat, endpoint, postData, title, dialogOpen, setDialogOpen }) => {
  const { ax } = useContext(GlobalStateContext)
  const [rows, setRows] = useState([])

  useEffect(() => {
    if (dialogOpen) {
      ax.post(endpoint, postData).then(value => {
        if (value.data) {
          setRows(value.data.map((row, i) => ({ ...row, id: i + 1, No: i + 1 })))
        }
      })
    } else {
      setRows([])
    }
  }, [dialogOpen, endpoint, postData, ax])

  const dynamicColumns = useMemo(() => (columns || []).map(field => {
    const fmt = datetimeFormat?.[field]
    return {
      field,
      headerName: colNm?.[field] || field,
      width: width?.[field] ?? 100,
      ...(fmt
        ? { valueFormatter: ({ value }) => value ? dayjs(value).format(fmt) : "-" }
        : {}),
    }
  }), [columns, colNm, width, datetimeFormat])

  const allColumns = useMemo(() => [...FIXED_FIRST, ...dynamicColumns, ...FIXED_LAST], [dynamicColumns])

  const handleClose = useCallback(() => setDialogOpen(false), [setDialogOpen])

  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth="xl">
      <DialogHeader handleDialogClose={handleClose} title={title || "ข้อมูล"} onDeleteClick={null} />
      <DialogContent>
        <BoxFC pt={2}>
          <Box height={450}>
            <DataGridCellExpand
              density="compact"
              hideFooter
              rows={rows}
              columns={allColumns}
            />
          </Box>
        </BoxFC>
      </DialogContent>
    </Dialog>
  )
}

export default React.memo(LogViewDialog)
